export const USER_SEARCH_LIMIT = 10;

export const USER_SEARCH_MIN_LENGTH = 3;

export const USER_STATUS = {
  DISABLED: "DISABLED",
  ENABLED: "ENABLED",
  PENDING: "PENDING",
} as const;

export type UserStatusT = (typeof USER_STATUS)[keyof typeof USER_STATUS];
